import { Stack } from '@landler/component-library';
import { Fragment } from 'react';

import { Icon } from '@/components/widgets/a/Icon/Icon';
import { useIsConservation } from '@/hooks/useIsConservation';

import { BreadcrumbSegment } from './BreadcrumbSegment';
import { useBreadcrumbs } from './useBreadcrumbs';

export const Breadcrumbs = () => {
  const isConservation = useIsConservation();
  const items = useBreadcrumbs();

  if (isConservation) return null;

  return (
    <div className='sticky top-0 z-appbar w-full bg-[#FFFFFF] py-2'>
      <Stack className='items-center flex-wrap mt-2 mx-4' direction='row'>
        {items.map((item, index) => (
          <Fragment key={item.key}>
            {index > 0 && (
              <Icon icon='ri-arrow-right-s-line' className='text-text-secondary text-base/none flex-shrink-0' />
            )}
            <BreadcrumbSegment {...item} />
          </Fragment>
        ))}
      </Stack>
    </div>
  );
};
